import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/performance';
import 'firebase/storage';

// Firebase init
const config = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTID,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID,
};
firebase.initializeApp(config);
firebase.performance();

// Firebase Auth
const { auth } = firebase;
// const auth = firebase.auth();
// const { currentUser } = auth;
// const currentUser = () => {
//   return firebase.auth().currentUser;
// };

const authValues = {
  googleAuth: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  facebookAuth: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
  emailAuth: firebase.auth.EmailAuthProvider.PROVIDER_ID,
  emailMethod: firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
  passwordMethod: firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD,
  // anonymousAuth: firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID,
  // credentialHelper: firebaseui.auth.CredentialHelper.NONE,
};

// signInMethods can contain 2 different strings for email auth:
// 'emailLink' if the user previously signed in with an email/link
// 'password' if the user has a password.
// A user could have both.
const getSignInMethods = async email => {
  try {
    let signInMethods = [];
    if (email) {
      signInMethods = await auth().fetchSignInMethodsForEmail(email);
    }
    return {
      signInMethods,
      hasGoogle: signInMethods.indexOf(authValues.googleAuth) !== -1,
      hasApple: signInMethods.indexOf('apple.com') !== -1,
      hasPassword: signInMethods.indexOf(authValues.passwordMethod) !== -1,
    };
  } catch (error) {
    console.error('Error getting sign-in methods', error);
    return {};
  }
};

// Analytics
const analytics = firebase.analytics();

// Firestore
const db = firebase.firestore();

db.enablePersistence({ synchronizeTabs: true }).catch(error => {
  console.log('No offline capability', error);
});

const dbFieldValue = firebase.firestore.FieldValue;
const serverTimestamp = () => {
  return firebase.firestore.FieldValue.serverTimestamp();
};
const currentTimestamp = () => {
  return firebase.firestore.Timestamp.fromDate(new Date());
};
// Needs Date object, i.e. moment().toDate()
const convertToTimestamp = date => {
  return firebase.firestore.Timestamp.fromDate(date);
};

const audioCollection = db.collection('audio');
const cardsCollection = db.collection('cards');
const configsCollection = db.collection('configs');
const postsCollection = db.collection('posts');
const stacksCollection = db.collection('stacks');
const stringsCollection = db.collection('strings');
const usersCollection = db.collection('users');

// Storage
const storage = firebase.storage();

// Functions
const functions = firebase.functions();

// Firebase Project: Dev or Prod
const isDevProject = config.projectId === 'imaginarie-app-dev';

const fb = {
  db,
  auth,
  authValues,
  getSignInMethods,
  analytics,
  dbFieldValue,
  convertToTimestamp,
  serverTimestamp,
  currentTimestamp,
  audioCollection,
  cardsCollection,
  configsCollection,
  postsCollection,
  stacksCollection,
  stringsCollection,
  usersCollection,
  storage,
  functions,
  isDevProject,
};

export default fb;
